// extracted by mini-css-extract-plugin
export default {"main":"style_main__dtrzq","container":"style_container__udMO8","heading":"style_heading__d57an","legend":"style_legend__D+chZ"};